import React from 'react'

export default function Dashboard() {
  return (
    <div class="alert alert-success" role="alert">
  <h4 class="alert-heading">Well done!</h4>
  <p>Thank You for register on our website</p>
  <hr/> 
  <p>You will get Confirmation email soon!</p>
</div>
  )
}
